import { Component, Input, OnInit } from '@angular/core';
import { AppUserState } from '../../stores/states/app.state';

@Component({
  selector: 'app-profile-image-stack',
  templateUrl: './profile-image-stack.component.html',
  styleUrls: ['./profile-image-stack.component.scss'],
})
export class ProfileImageStackComponent implements OnInit {
  @Input() members: AppUserState[] = [];
  backgroundColors = [
    'bg-red-500',
    'bg-green-500',
    'bg-blue-500',
    'bg-yellow-500',
    'bg-purple-500',
  ];
  @Input() MAX: number = 6;
  @Input() config: any = {
    size: 'w-8 h-8 text-sm',
  };
  @Input() hideTooltip: boolean = true;
  ngOnInit(): void {
    this.assignColors();
  }

  // defaultColor = '#6f83f7';

  assignColors(): void {
    if (this.members === undefined) return;
    const assignedColors = JSON.parse(
      localStorage.getItem('assignedMemberColors') || '{}',
    );
    let lastAssignedColor = '';
    const updatedMembers = this.members.map((member) => {
      if (!member.image) {
        let color;
        if (assignedColors[member.sub]) {
          color = assignedColors[member.sub];
        } else {
          color = this.getDifferentColor(lastAssignedColor, assignedColors);
          assignedColors[member.sub] = color;
        }
        lastAssignedColor = color;
        return { ...member, bgColor: color };
      }
      return member;
    });
    this.members = updatedMembers;
    localStorage.setItem(
      'assignedMemberColors',
      JSON.stringify(assignedColors),
    );
  }

  getDifferentColor(
    lastColor: string,
    assignedColors: { [key: string]: string },
  ): string {
    let availableColors = this.backgroundColors.filter(
      (color) => color !== lastColor,
    );
    if (availableColors.length === 0) {
      availableColors = this.backgroundColors;
    }
    let color =
      availableColors[Math.floor(Math.random() * availableColors.length)];
    if (color === lastColor && availableColors.length > 1) {
      const alternativeColors = availableColors.filter((c) => c !== lastColor);
      color =
        alternativeColors[Math.floor(Math.random() * alternativeColors.length)];
    }
    return color;
  }

  getInitials(name: string): string {
    return name
      .split(' ')
      .slice(0, 2)
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  }
}
